import React from 'react';

const CustomButton = ({ children }) => {
  return (
    <button
      className="w-fit p-2 px-4 text-white rounded-t-full rounded-br-full cursor-auto"
      style={{
        background: 'linear-gradient(45deg, #56CCF2 30%, #2F80ED 90%)',
      }}
    >
      {children}
    </button>
  );
};

export default CustomButton;
